import { Component, OnInit } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { delay } from 'rxjs';
import { maximumLostPercentOptions } from '../../services/ref';

import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'maximum-lost-percent',
    templateUrl: './maximum-lost-percent.component.html',
    styleUrls: ['./maximum-lost-percent.component.scss'],
    standalone: false
})
export class MaximumLostPercentComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  options = maximumLostPercentOptions;
  error: ValidationErrors = null;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
    const productType = this.subscriptionFacade.getPledge()?.productType || '';
    const type =
      productType !== 'SCPI' ? productType?.toLowerCase() : productType;
    const message = `Si vous souhaitez réaliser un investissement à capital et/ou revenus garantis, l'investissement en parts de ${type} n'est pas adapté à vos objectifs. Veuillez vous rapprocher de votre conseiller pour obtenir des renseignements complémentaires.`;

    this.form
      .get('maximumLostPercent')
      .valueChanges.pipe(
        delay(0),

        untilDestroyed(this),
      )
      .subscribe(data => {
        if (['PERCENT_0', 'PERCENT_1_5', 'PERCENT_6_10']?.includes(data)) {
          this.form.get('maximumLostPercent').setErrors({
            incorrect: true,

            message: message,
          });
        } else {
          this.form.get('maximumLostPercent').setErrors(null);
        }
        this.error = this.form.get('maximumLostPercent').errors;
      });
  }

  onSubmit() {
    this.form.markAsDirty();
    if (!this.error) {
      this.subscriptionFacade.submitPledge(this);
    }
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
